import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import UserStoriesItem from './UserStoriesItem';
import DefaultAvatar from '../images/default_avatar.jpg';
import {s3Link} from '../utils/constants';
import {checkImageExist} from '../utils/helper'

// user is the pfole page being viewed
const ViewStory = ({ currentUser, user, show, onHide, avatar }) => {
    return (
        <>
            <Modal className="story-modal" show={show} onHide={onHide} centered>
                {/* <button className="story-close" onClick={onHide}>
                    <FontAwesomeIcon icon={['fa', 'times']} />
                </button> */}
                <Modal.Body>
                    <UserStoriesItem currentUser={currentUser} user={user} hide={onHide} avatar={avatar} />
                </Modal.Body>
            </Modal>
        </>
    );
}
export default ViewStory;